import React, { useEffect, useState } from "react";
import { StyleSheet, View, useWindowDimensions } from "react-native";
import { BlurView } from "expo-blur";
import { LinearGradient } from "expo-linear-gradient";

import { Spacings } from "@/styling/spacings";

interface PlaceHolderImageProps {
  bgColors: string[];
  numColumns: number;
  blurIntensity?: number;
}

function getRandomColor(): string {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

function PlaceHolderImage({
  bgColors,
  numColumns,
  blurIntensity = 50,
}: PlaceHolderImageProps): React.JSX.Element {
  const { width } = useWindowDimensions();
  const itemWidth = (width - Spacings.s1 * (numColumns + 1)) / numColumns;
  const itemHeight = (itemWidth / 3) * 4;
  const imageActionBarHeight = 27;

  const [colors, setColors] = useState([
    getRandomColor(),
    getRandomColor(),
  ] as const);

  useEffect(() => {
    if (bgColors.length === 0) {
      setColors([getRandomColor(), getRandomColor()]);
    }
  }, []);

  return (
    <View>
      <LinearGradient
        colors={colors}
        style={[
          styles.container,
          { height: itemHeight + imageActionBarHeight, width: itemWidth },
        ]}
      >
        <BlurView intensity={blurIntensity} style={StyleSheet.absoluteFill} />
      </LinearGradient>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    borderRadius: 10,
    flex: 1,
    justifyContent: "center",
    overflow: "hidden",
  },
});

export default PlaceHolderImage;
